import LogicDistilleryAndFactory from "./receiptTools/logicDisilleryAndFactory";
import MappingReceipt from "../../../../../../public/papconfig/MappingReceive"

const ReceiptControl = async function(properties = new Array()) {
    try {
        await receiptControl.updateComponentWithZeroFlow(properties)
    } catch (e) {
        console.log(`ReceiptCotntrol: Falhar ao receber os dados. ${e}`)
    }

    try {
        LogicDistilleryAndFactory.Apply(properties)
    } catch (e) {
        console.log(`ReceiptCotntrol: Falhar ao receber os dados. ${e}`)
    }

    try {
        MappingReceipt(properties)
    } catch (e) {
        console.log(`MappingReceipt: Falhar ao receber os dados. ${e}`)
    }
}

export default ReceiptControl

const receiptControl = {
    updateComponentWithZeroFlow: async(props) => {
        try {
            let arrayOfIndex = [];
            await props.forEach(element => {
                if (element.key == 'WVol' && element.value == "0,00") {
                    arrayOfIndex.push(element.index)
                }
            });
            await props.forEach(element => {
                arrayOfIndex.forEach(index => {
                    if (element.index == index && !element.isInput) {
                        element.value = "0,00"
                    }
                });
            });
        } catch (e) {
            throw `Falha no método updateComponentWithZeroFlow \n${e}`
        }
    },
}